import { useEffect, useState } from 'react';
import { getNews } from '../services/firestoreService';
import { NewsItem } from '../types';
import { NewsCard } from '../components/News';
import PageShell from '../components/PageShell';

const NewsArchive = () => {
  const [news, setNews] = useState<NewsItem[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    getNews().then(setNews).catch(() => setError(true));
  }, []);

  return (
    <PageShell title="Actualités">
      <p className="eyebrow mb-3">Le journal</p>
      <h1 className="heading text-4xl md:text-5xl mb-10">Toutes nos actualités</h1>

      {error ? (
        <p className="text-red-600">Impossible de charger les actualités pour le moment.</p>
      ) : news === null ? (
        <p className="text-brand-pink-600">Chargement...</p>
      ) : news.length === 0 ? (
        <p className="text-brand-pink-900/70">Aucune actualité pour le moment.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map(item => <NewsCard key={item.id} item={item} />)}
        </div>
      )}
    </PageShell>
  );
};

export default NewsArchive;
